var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tenants-show-view"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isSuccessfullyLoaded) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.tenant.name))]), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? [_c('link-button', {
    attrs: {
      "to": {
        name: 'edit-tenant',
        params: {
          id: _vm.tenant.id
        }
      },
      "icon": "pencil"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.edit')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.providers')))]), _vm._v(" "), _c('tenant-provider-manager', {
    attrs: {
      "tenant": _vm.tenant
    }
  })] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.tokens')))]), _vm._v(" "), _c('auth-token-manager', {
    attrs: {
      "resource": _vm.tenant
    },
    on: {
      "update": _vm.updateAuthTokens
    }
  }), _vm._v(" "), (_vm.tenant.colors.length) ? [_c('h3', [_vm._v(_vm._s(_vm.$t('headlines.colorPalette')))]), _vm._v(" "), _c('color-table', {
    attrs: {
      "colors": _vm.tenant.colors
    }
  })] : _vm._e()], 2) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b131fb92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Tenants/ShowView.vue
// module id = 2096
// module chunks = 0